import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["display", "overlay", "countdown"]
  static values = {
    remainingSeconds: Number,
    durationSeconds: Number,
    resultsUrl: String
  }

  connect() {
    this.deadline = Date.now() + this.remainingSecondsValue * 1000
    this.tick()
    this.interval = setInterval(() => this.tick(), 100)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000))

    if (remaining > this.durationSecondsValue) {
      this.countdownTarget.textContent = remaining - this.durationSecondsValue
      this.displayTarget.textContent = this.format(this.durationSecondsValue)
      return
    }

    if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden")

    this.displayTarget.textContent = this.format(remaining)
    this.displayTarget.classList.toggle("text-red-600", remaining <= 30)

    if (remaining <= 0) {
      clearInterval(this.interval)
      Turbo.visit(this.resultsUrlValue)
    }
  }

  format(seconds) {
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`
  }
}
